/** Scroll target for the price-guarantee widget "Select Tickets" CTA. */
export const PROMOTIX_SELECT_TICKETS_ANCHOR_ID = 'promotix-select-tickets';

export const PRICE_GUARANTEE_WIDGET_SELECTOR = '[data-testid="price-guarantee-widget"]';

function stickyListingChromeOffsetPx() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return 96;
  const style = getComputedStyle(document.documentElement);
  const useDesktop = window.matchMedia('(min-width: 768px)').matches;
  const topbarRaw = style
    .getPropertyValue(useDesktop ? '--topbarHeightDesktop' : '--topbarHeight')
    .trim();
  const bannerRaw = style.getPropertyValue('--listingRewardsBannerHeight').trim();
  const topbar = Number.isFinite(parseInt(topbarRaw, 10))
    ? parseInt(topbarRaw, 10)
    : useDesktop
    ? 72
    : 60;
  const banner = Number.isFinite(parseInt(bannerRaw, 10)) ? parseInt(bannerRaw, 10) : 36;
  return topbar + banner;
}

export function scrollToPromotixSelectTickets() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const chrome = stickyListingChromeOffsetPx();
  const mapAnchor = document.getElementById(PROMOTIX_SELECT_TICKETS_ANCHOR_ID);

  // Align the map band under sticky topbar + rewards banner so the price widget
  // (sibling above the map) scrolls fully off-screen.
  if (mapAnchor) {
    window.scrollTo({
      top: Math.max(0, mapAnchor.getBoundingClientRect().top + window.scrollY - chrome),
      behavior: 'smooth',
    });
    return;
  }

  const widget = document.querySelector(PRICE_GUARANTEE_WIDGET_SELECTOR);
  if (widget) {
    const integrationBand = widget.parentElement;
    const bandBottom =
      integrationBand instanceof HTMLElement
        ? integrationBand.getBoundingClientRect().bottom + window.scrollY
        : widget.getBoundingClientRect().bottom + window.scrollY;
    window.scrollTo({ top: Math.max(0, bandBottom - chrome + 8), behavior: 'smooth' });
  }
}
